import { purchaseCodesList } from "../../Purchases/Helper";
import { CurrencyE, SelectedOptionE } from "../models/enums";
import type { PlanPricesDetailsT } from "../models/models";

const getPrices = (planPrices: PlanPricesDetailsT, currency: CurrencyE) => {
  return {
    monthly: planPrices ? planPrices.Price_Monthly[currency] : 0,
    yearly: planPrices ? planPrices.Price_Yearly[currency] : 0,
    // JUMBOcodes
    "5": purchaseCodesList?.find(
      ({ num }) => num === SelectedOptionE.FIVE_CODES
    )?.price[currency],
    "10": purchaseCodesList?.find(
      ({ num }) => num === SelectedOptionE.TEN_CODES
    )?.price[currency],
    "20": purchaseCodesList?.find(
      ({ num }) => num === SelectedOptionE.TWENTY_CODES
    )?.price[currency],
  };
};

export default getPrices;
